import { Theme } from '@eversports/react-components/design-tokens/theme'
import { TableCell } from '@eversports/react-components/primitives/Table'
import { withStyles } from '@mui/styles'

const ProductTableCell = withStyles((theme: Theme) => ({
  root: {
    padding: `${theme.layoutSpacing.dense} ${theme.layoutSpacing.none}`,
    '&:last-child': {
      paddingRight: theme.layoutSpacing.none,
    },
    [theme.breakpoints.down('md')]: {
      paddingRight: theme.spacing(2),
    },
  },
}))(TableCell)

export default ProductTableCell
